import { TeamsCollaborationSecWrapper } from "../../styles/StyledComponents/VideoSecWrapper";
import assests from "../../ui/assests";
import CommonHeading from "../CommonHeading/CommonHeading";

const TeamsCollaborationSec = () => {
  return (
    <TeamsCollaborationSecWrapper className="cmn_gap_btm">
      <div className="container">
        <div className="row collaboration_row">
          <div className="col ">
            <CommonHeading
            alignText="left"
              title="A Team That Thrives on Creativity & Collaboration"
              paratext="We believe in empowering our team to grow, share ideas, and push boundaries. 
              At EMIIT, you're not just an employee—you’re part of a dynamic group that's passionate 
              about building exceptional digital experiences."
            />
          </div>
          <div className="col">
            <figure>
              <img src={assests.collboration} alt="collboration" />
            </figure>
          </div>
        </div>
      </div>
    </TeamsCollaborationSecWrapper>
  );
};

export default TeamsCollaborationSec;
